export enum ResidenceType {
  Citizen = 1,
  Resident,
}
